import { Directive, HostListener, ElementRef, OnInit, HostBinding, Input } from "@angular/core";
import { AppCurrencyPipe } from "../pipes/currency.pipe";


@Directive({
    selector: "[currencyformat]",
    standalone: false
})
export class CurrencyFormatterDirective implements OnInit {

  @Input() currencyformat: number | string = 2;

  private el: HTMLInputElement;

  constructor(
    private elementRef: ElementRef,
    private AppCurrencyPipe: AppCurrencyPipe
  ) {
    this.el = this.elementRef.nativeElement;
  }

  get fractionSize(): number {
    return typeof this.currencyformat === 'number' ? this.currencyformat : parseInt(this.currencyformat) || 2;
  }

  ngOnInit() {
    this.el.value = this.AppCurrencyPipe.transform(this.el.value, this.fractionSize);
  }

  @HostListener("focus", ["$event.target.value"])
  onFocus(value) {
    this.el.value = this.AppCurrencyPipe.parse(value, this.fractionSize);
  }

  @HostListener("blur", ["$event.target.value"])
  onBlur(value) {
    this.el.value = this.AppCurrencyPipe.transform(value, this.fractionSize);
  }
}
